export interface ApiConfig {
  subBaseUrlhttp: string;
  baseUrl?: string;
}

export function buildApiUrl(config: ApiConfig, path: string): string {
  const baseUrl = (config.baseUrl || '/api').replace(/\/+$/, '');
  return `${baseUrl}/${path.replace(/^\/+/, '')}`;
}
